import { colors } from "../assets/colors";

interface Props {
  text: string;
  color?: string;
}

export default function Badge({ color, text }: Props) {
  return (
    <div
      style={{
        backgroundColor: color,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 100,
        display: 'flex',
      }}>
      <span style={{
        color: colors.white,
        fontSize: 12,
        marginLeft: 8,
        marginRight: 8,
        marginTop: 6,
        marginBottom: 6
      }}>{text}</span>
    </div>
  );
}

